import type { PropsWithChildren } from 'react'

export function ControlPanelContainer({ children }: PropsWithChildren) {
  return (
    <div className="flex justify-end min-h-[20px] px-[12px] py-[8px] items-center self-stretch bg-tertiary-background">
      {children}
    </div>
  )
}

export function FilterContainer({ children }: PropsWithChildren) {
  return <div className="flex items-center gap-[8px]">{children}</div>
}
